import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const GrowthDesk = lazy(() => import('../components/GrowthDesk'));

const growthDeskRoute: RouteObject = {
  path: 'growth-desk',
  element: <GrowthDesk />,
};

export default growthDeskRoute;
